<template>
  <div class="wrapper">
    <div class="page-header page-header-large">
      <parallax
        class="page-header-image"
        style="background-image: url('img/presentation/product_main.png')"
      ></parallax>

      <!-- platform-connected-cars.png -->

      <div class="content-center">
        <div class="row">
          <div class="col-md-12 ml-auto mr-auto">
            <h4 class="title">AiCAR’s Ecosystem of Services</h4>
            <h8 class="description">
              AiCAR is a market leader in auto-tech innovation and has aggregated differentiated services for the connected car. We focus on services that save users time and money, as well as prioritising their safety. Our flexible technology allows users to freely change their vehicles, as well as select their preferred service providers.
            </h8>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <img class="img" alt="Raised Image" src="img/ecosystem-services/connected-cars-ecosystem-services-ac.png" />
          </div>
        </div>
      </div>

      <!-- 
            <div class="about-office">
                <div class="container">
                    <div class="row text-center">
                        <div class="col-md-8 ml-auto mr-auto">
                            <h2 class="title">Our office is our second home</h2>
                            <h4 class="description">Here are some pictures from our office. You can see the place
                                looks like a palace and is fully equiped with everything you need to get the job
                                done.</h4>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-4">
                            <img class="rounded img-raised" alt="Raised Image" src="img/bg27.jpg">
                        </div>
                        <div class="col-md-4">
                            <img class="rounded img-raised" alt="Raised Image" src="img/bg24.jpg">
                        </div>
                        <div class="col-md-4">
                            <img class="rounded img-raised" alt="Raised Image" src="img/bg28.jpg">
                        </div>
                        <div class="col-md-6">
                            <img class="rounded img-raised" alt="Raised Image" src="img/project6.jpg">
                        </div>
                        <div class="col-md-6">
                            <img class="rounded img-raised" alt="Raised Image" src="img/project14.jpg">
                        </div>
                    </div>
                </div>
            </div>
      -->
    </div>


  </div>
</template>
<script>
import {
  Card,
  Button,
  Badge,
  InfoSection,
  FormGroupInput,
  Checkbox
} from "@/components";
import { Select, Option } from "element-ui";

export default {
  name: "about-us",
  bodyClass: "about-us",
  components: {
    Card,
    InfoSection,
    Badge,
    [Button.name]: Button,
    [Checkbox.name]: Checkbox,
    [FormGroupInput.name]: FormGroupInput,
    [Select.name]: Select,
    [Option.name]: Option
  },
  data() {
    return {
      form: {
        firstName: "",
        email: "",
        speciality: ""
      }
    };
  }
};
</script>
<style>
</style>
